let Properties = {
    store: {
        namespaced: true
    },
    components: {},
    api: {}
};